import type { ReactNode } from 'react';
import cx from 'classnames';
import { LoadingIcon, SvgIcon } from '@/components';
import styles from './StateInfoBox.module.sass';

export type StateInfoBoxType = 'loading' | 'info' | 'success' | 'error';

interface StateInfoBoxProps {
  type: StateInfoBoxType;
  title?: string;
  children?: ReactNode;
  className?: string;
}

const StateInfoBox = ({ type, title, children, className }: StateInfoBoxProps) => {
  const iconByType = {
    loading: <LoadingIcon />,
    info: <SvgIcon name="circle-info" className={styles.icon} />,
    success: <SvgIcon name="circle-checkmark" className={styles.icon} />,
    error: <SvgIcon name="circle-warning" className={styles.icon} />,
  };

  const classes = cx(
    styles.state,
    {
      [styles[`state--${type}`]]: type,
    }, className
  );

  return (
    <div className={classes}>
      {iconByType[type]}
      {title && <div className={styles.title}>{title}</div>}
      {children && <div className={styles.content}>{children}</div>}
    </div>
  );
};

export default StateInfoBox;
